
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

export default {
    name: 'project',
    components: {
        Timeline,
        TimelineItem
    },
    data() {
        return {
            count: 3
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/github.vue